import React from 'react';
import { Star } from 'lucide-react';
interface PricingTiersProps {
  selectedTier: 'standard' | 'bundle';
  onSelectTier: (tier: 'standard' | 'bundle') => void;
}
export function PricingTiers({
  selectedTier,
  onSelectTier
}: PricingTiersProps) {
  return <div className="space-y-4 my-6" data-id="element-146">
      <div className="relative" data-id="element-147">
        <div className="absolute -top-3 left-4 bg-background px-2 text-xs font-semibold text-textSecondary uppercase tracking-wider z-10" data-id="element-148">
          Comprando te llevas gratis:
        </div>
        <div className="border border-primary/20 rounded-xl p-4 bg-surface/50 space-y-3 pt-6 relative overflow-hidden" data-id="element-149">
          {/* Standard Tier */}
          <button onClick={() => onSelectTier('standard')} className={`w-full flex items-center p-3 rounded-lg border transition-all duration-300 text-left ${selectedTier === 'standard' ? 'glow-border-active bg-primary/10' : 'border-primary/20 bg-surface hover:border-primary/50'}`} data-id="element-150">
            <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mr-4 flex items-center justify-center ${selectedTier === 'standard' ? 'border-primary' : 'border-textSecondary'}`} data-id="element-151">
              {selectedTier === 'standard' && <div className="w-2.5 h-2.5 rounded-full bg-primary glow-text" data-id="element-152" />}
            </div>

            <div className="flex-1" data-id="element-153">
              <h3 className="font-bold text-sm md:text-base uppercase" data-id="element-154">
                2026 EDITING ARSENAL
              </h3>
              <p className="text-xs text-textSecondary mt-0.5" data-id="element-155">
                Precio estándar
              </p>
            </div>

            <div className="text-right" data-id="element-156">
              <span className="text-xs text-textSecondary line-through mr-2" data-id="element-157">
                $769.000
              </span>
              <span className="font-bold text-primary text-lg" data-id="element-158">$29.000</span>
            </div>
          </button>

          {/* Bundle Tier */}
          <button onClick={() => onSelectTier('bundle')} className={`w-full flex items-start p-4 rounded-lg border transition-all duration-300 text-left relative overflow-hidden ${selectedTier === 'bundle' ? 'glow-border-active bg-primary/10' : 'border-primary/20 bg-surface hover:border-primary/50'}`} data-id="element-159">
            {/* Popular Badge */}
            <div className="absolute top-0 right-0 bg-primary text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg flex items-center" data-id="element-160">
              <Star className="w-3 h-3 mr-1 fill-current" data-id="element-161" /> MAS POPULAR{' '}
              <Star className="w-3 h-3 ml-1 fill-current" data-id="element-162" />
            </div>

            <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mr-4 mt-1 flex items-center justify-center ${selectedTier === 'bundle' ? 'border-primary' : 'border-textSecondary'}`} data-id="element-163">
              {selectedTier === 'bundle' && <div className="w-2.5 h-2.5 rounded-full bg-primary glow-text" data-id="element-164" />}
            </div>

            <div className="flex-1" data-id="element-165">
              <h3 className="font-bold text-sm md:text-base uppercase pr-24 leading-tight" data-id="element-166">
                EDICIÓN PRO: DE 0 A PROFESIONAL 2026
              </h3>

              <div className="flex items-baseline mt-2 mb-3" data-id="element-167">
                <span className="text-sm text-textSecondary line-through mr-2" data-id="element-168">
                  $989.000
                </span>
                <span className="font-bold text-primary text-xl" data-id="element-169">$59.000</span>
              </div>

              <ul className="space-y-1.5 text-xs text-textSecondary" data-id="element-170">
                <li className="flex items-start" data-id="element-171">
                  <span className="text-primary mr-2" data-id="element-172">•</span>
                  2026 EDITING ARSENAL ($29.000 ARS)
                </li>
                <li className="flex items-start" data-id="element-173">
                  <span className="text-primary mr-2" data-id="element-174">•</span>
                  MASTERCLASS CONTENIDO CON IA ($89.000 ARS)
                </li>
                <li className="flex items-start" data-id="element-175">
                  <span className="text-primary mr-2" data-id="element-176">•</span>
                  CURSO COMPLETO EDICIÓN EN CAPCUT ($159.000 ARS)
                </li>
                <li className="flex items-start" data-id="element-177">
                  <span className="text-primary mr-2" data-id="element-178">•</span>
                  COMUNIDAD DE EDITORES Y BOLSA DE TRABAJO (INVALUABLE)
                </li>
              </ul>
            </div>
          </button>
        </div>
      </div>
    </div>;
}